/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  getWhatsAppTemplates(inboxId, params = {}) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_templates`, { params });
  }

  getWhatsAppTemplateAnalytics(inboxId, params = {}) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_templates/analytics`, {
      params,
    });
  }

  getWhatsAppSingleTemplateAnalytics(inboxId, templateId, params = {}) {
    return axios.get(
      `${this.url}/${inboxId}/whatsapp_templates/${templateId}/analytics`,
      { params }
    );
  }

  getWhatsAppTemplate(inboxId, templateId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_templates/${templateId}`);
  }

  createWhatsAppTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates`, {
      template,
    });
  }

  updateWhatsAppTemplate(inboxId, templateId, template) {
    return axios.patch(
      `${this.url}/${inboxId}/whatsapp_templates/${templateId}`,
      { template }
    );
  }

  deleteWhatsAppTemplate(inboxId, templateId, templateName) {
    return axios.delete(
      `${this.url}/${inboxId}/whatsapp_templates/${templateId}`,
      { params: { name: templateName } }
    );
  }

  uploadWhatsAppTemplateMedia(inboxId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(
      `${this.url}/${inboxId}/whatsapp_templates/upload_media`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }
}

export default new Inboxes();
